module.exports = __webpack_public_path__ + "img/redlock.31932f96.svg";